import { useMemo, useState } from "react";
import { formatCompact, formatUsd, shorten } from "../lib/format";
import type { Market } from "../lib/types";
import { TokenAvatar } from "./TokenAvatar";

export function MarketList(props: {
  markets: Market[];
  selectedMint?: string;
  onSelect: (market: Market) => void;
  loading: boolean;
  solUsdPrice?: number;
}) {
  const { markets, selectedMint, onSelect, loading, solUsdPrice } = props;
  const [query, setQuery] = useState("");
  const visible = useMemo(() => {
    const normalized = query.trim().toLowerCase();
    return markets.filter((market) => {
      return (
        !normalized ||
        market.name.toLowerCase().includes(normalized) ||
        market.symbol.toLowerCase().includes(normalized) ||
        market.mint.toLowerCase().includes(normalized)
      );
    });
  }, [markets, query]);

  return (
    <section className="market-panel panel">
      <div className="panel-heading">
        <h2>Tokens</h2>
        <span className="market-count">{markets.length}</span>
      </div>
      <label className="search-box">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m21 21-4.35-4.35m2.35-5.4A7.75 7.75 0 1 1 3.5 11.25a7.75 7.75 0 0 1 15.5 0Z" /></svg>
        <input
          type="search"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          placeholder="Search tokens"
          aria-label="Search tokens"
        />
      </label>
      <div className="market-columns" aria-hidden="true">
        <span>Token</span><span>Market cap</span><span>Status</span>
      </div>
      <div className="market-list">
        {loading && markets.length === 0
          ? Array.from({ length: 7 }, (_, index) => <div className="market-skeleton" key={index} />)
          : visible.map((market) => (
              <button
                key={market.pool}
                className={`market-row ${selectedMint === market.mint ? "selected" : ""}`}
                onClick={() => onSelect(market)}
              >
                <span className="market-token">
                  <TokenAvatar name={market.name} symbol={market.symbol} image={market.image} />
                  <span><strong>{market.symbol}</strong><small>{market.name || shorten(market.mint)}</small></span>
                </span>
                <span className="market-stat">
                  <strong>{formatUsd(solUsdPrice === undefined ? undefined : market.marketCapSol * solUsdPrice)}</strong>
                  <small>{formatCompact(market.marketCapSol)} SOL</small>
                </span>
                <span className="access-badge public">
                  <i /> Live
                </span>
              </button>
            ))}
        {!loading && visible.length === 0 && (
          <div className="empty-state"><strong>No tokens found</strong><span>Try another search or filter.</span></div>
        )}
      </div>
    </section>
  );
}
